const DEFAULT_MAX_LENGTH = 140;

export const isTextLengthValid = (text: string, maxLength: number = DEFAULT_MAX_LENGTH): boolean => {
  return text.length < maxLength;
};
